import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const FraudName = (props) => {
  let { required, name, label } = props;

  if (name === undefined) {
    name = "name";
  }

  if (label === undefined) {
    label = "First Name";
  }

  if (required === undefined) {
    required = false;
  }

  let complete = "given-name";
  if (name === "surname") {
    complete = "family-name";
  }

  const isValid = (x) => { 
    const re = /^[ "&-.0-:A-Za-z]{1,20}$/;
    return (x || !required) &&
      (re.test(x) || (!required && (x === undefined || x?.length === 0)))
      ? undefined
      : " A valid " + label + " must be provided";
  };

  return (
    <Field
      name={name}
      validate={isValid}
      label={label}
      autoComplete={complete}
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: 20 }}
    />
  );
};

export default FraudName;
